<template>
  <v-chip
    small
    v-bind="$attrs"
    outlined
    :to="{
      name: 'TeacherDepartments',
      params: { id: value.id },
    }"
  >
    <Icon left small>mdi-account-details</Icon>
    {{ value.description }}
  </v-chip>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "DepartmentChip",
  props: {
    value: { type: Object, default: null },
  },
});
</script>
